import { fmtMoney, fmtPct } from "@/lib/api";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

/**
 * Stat — large, calm number-led metric.
 *
 * No card frame by default. Compose inside <Card> if needed.
 * Size: "lg" (executive headline, ~36px) | "md" (24px) | "sm" (18px)
 */
export function Stat({
    label,
    value,
    formatted,
    money = true,
    delta,
    deltaLabel,
    helper,
    size = "md",
    tone = "default",          // default | positive | negative | warning
    testId,
}) {
    const sizes = {
        lg: "text-[2.25rem] leading-[1.05]",
        md: "text-[1.625rem] leading-[1.1]",
        sm: "text-lg leading-tight",
    };

    const display = formatted !== undefined
        ? formatted
        : money
            ? fmtMoney(value)
            : (value !== undefined && value !== null ? value : "—");

    const toneCls = {
        default: "text-stone-900",
        positive: "text-emerald-700",
        negative: "text-red-700",
        warning: "text-amber-700",
    }[tone] ?? "text-stone-900";

    const deltaPositive = typeof delta === "number" && delta >= 0;
    const DeltaIcon = delta === undefined || delta === null
        ? Minus
        : deltaPositive
            ? TrendingUp
            : TrendingDown;

    return (
        <div data-testid={testId}>
            {label && (
                <div className="label-soft mb-2 text-stone-500">{label}</div>
            )}
            <div className={`font-mono-num ${sizes[size]} font-medium tracking-tight ${toneCls}`}>
                {display}
            </div>
            {(delta !== undefined && delta !== null) && (
                <div
                    className={`mt-2 inline-flex items-center gap-1 text-[13px] font-medium ${
                        deltaPositive ? "text-emerald-700" : "text-red-700"
                    }`}
                >
                    <DeltaIcon size={13} strokeWidth={2} />
                    <span className="font-mono-num">
                        {money ? fmtMoney(Math.abs(delta)) : fmtPct(Math.abs(delta))}
                    </span>
                    {deltaLabel && (
                        <span className="text-stone-500 font-normal ml-1">
                            {deltaLabel}
                        </span>
                    )}
                </div>
            )}
            {helper && (
                <div className="mt-2 text-[13px] text-stone-500 leading-snug">
                    {helper}
                </div>
            )}
        </div>
    );
}
